var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{ref:"qr-code-animation",staticClass:"qr-code-animation"})
}
var staticRenderFns = []

export { render, staticRenderFns }